import { FC } from "react";

import { SECONDARY_OVERLAY_QUERY_PARAM } from "components/constants";
import type { ButtonProps } from "mds/components/Button";
import { CloseButton } from "mds/components/CloseButton";
import { useQueryParamsManager } from "utils/routing";

type CloseOverlayButtonProps = Omit<ButtonProps<"button">, "onClick">;

export const CloseOverlayButton: FC<CloseOverlayButtonProps> = ({ size = "s", ...props }) => {
  const { deleteQueryParams } = useQueryParamsManager();

  const onClose = () => {
    deleteQueryParams([SECONDARY_OVERLAY_QUERY_PARAM]);
  };

  return <CloseButton eventName="Right Panel - Close" size={size} {...props} onClick={onClose} />;
};
